import { CompactionMarker } from '@inference.engine/agentic-ui/components';
import { AgenticUiText } from '@/shared/i18n/AgenticUiText';
import type { ConversationSummary } from '../api/conversation-summaries.api';

/** The markers that follow one message of a test conversation, one per summary ending there. */
export function CompactionMarkers({ summaries }: { summaries: readonly ConversationSummary[] }) {
  return (
    <AgenticUiText>
      {summaries.map((summary) => (
        <CompactionMarker key={summary.id} compaction={summary} />
      ))}
    </AgenticUiText>
  );
}
